import Icon from './src/Icon';

export default Icon;
